import React from 'react';
import {
  View, StyleSheet, Text, FlexStyle,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Button from '../../../Button';
import SensorsOfflineImage from '../../SensorsOffllineImage';
import Colors from '../../../../constants/Colors';
import { AppScreen } from '../../../../navigation/LinkingConfiguration';

interface SensorsOfflineProps {
  style?: FlexStyle | FlexStyle[],
  assetId?: string,
  title?: string,
}

const SensorsOffline = ({ style, assetId, title }: SensorsOfflineProps) => {
  const navigation = useNavigation();

  const navigateToAsset: () => void = () => {
    navigation.navigate(AppScreen.TEMPLATE_MANAGEMENT as any, { assetId });
  };

  return <View style={[styles.emptyState, style]}>
    <SensorsOfflineImage />
    <Text style={styles.emptyStateTitle}>{title ?? 'Sensors appear to be offline'}</Text>
    {!!assetId && <Button
      affirmative
      style={{ ...styles.goToButton, width: styles.requestSupportButton.width }}
      title='Go to asset'
      onPress={navigateToAsset}
    />}
    {false && <Button
      style={styles.requestSupportButton}
      title='Request support'
    />}
  </View>;
};

const styles = StyleSheet.create({
  emptyState: {
    alignItems: 'center',
  },
  emptyStateTitle: {
    fontSize: 22,
    lineHeight: 33,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
    alignSelf: 'center',
    marginVertical: 32,
  },
  goToButton: {
    marginStart: 0,
    marginBottom: 8,
  },
  requestSupportButton: {
    width: 170,
  },
});

export default SensorsOffline;
